export const typesReview = {
    GET_REVIEW_SUCCESS:'GET_REVIEW_SUCCESS',
    GET_REVIEW_ERROR:'GET_REVIEW_ERROR',
    GET_REVIEW_BEGIN:'GET_REVIEW_BEGIN',
    CREATE_ADDRESS: 'MYRESERVATIONS_PRIMARY_ADDRESS',

    GET_PRICEANDTAX_SUCCESS:'GET_PRICEANDTAX_SUCCESS',
    GET_PRICEANDTAX_ERROR:'GET_PRICEANDTAX_ERROR',
    GET_PRICEANDTAX_BEGIN:'GET_PRICEANDTAX_BEGIN',
    RESET_PRICEANDTAX_INIT: 'RESET_PRICEANDTAX_INIT'
}
